/*
  Aquamarise wishlist — theme-native, no third-party app. 2026-09-28 (Claude).

  Replaces Swish (Wishlist King). One deferred module, zero extra origins, no layout shift:
  the heart buttons and the header counter are rendered by Liquid; this file only wires them up.

  Storage  localStorage "aq_wishlist_v1" = { v: 1, email: "", items: [ { h, id, vid, t, img, price, cmp, url, avail, cur, ts, kl } ] }
           h = product handle (key), id = product id, vid = variant id saved from, kl = Klaviyo events already sent.
  Config   <script id="aq-wishlist-config" type="application/json"> from snippets/aq-wishlist-config.liquid.
  Events   document "aq:wishlist:change" { detail: { items } } after every change.
  Klaviyo  "Added to Wishlist" custom metric (reminder flow) + "Viewed Product" (feeds Klaviyo's native
           Price Drop flow, which only listens to Viewed Product / Started Checkout). Back in stock uses
           Klaviyo's client back-in-stock endpoint per variant. All calls are fire-and-forget.
  API      window.AQWishlist = { items, has, add, remove, toggle, count, email, setEmail, identify,
                                 subscribeBackInStock, syncToKlaviyo, shareUrl }
*/
(function () {
  'use strict';

  var KEY = 'aq_wishlist_v1';
  var KL_REVISION = '2026-07-15';
  var cfg = readConfig();
  var state = load();

  /* ---------------------------------------------------------------- storage */
  function readConfig() {
    var c = {};
    try { c = JSON.parse((document.getElementById('aq-wishlist-config') || {}).textContent || '{}'); } catch (e) {}
    if (!c.companyId) {
      var s = document.querySelector('script[src*="klaviyo.js"]');
      var m = s && s.src.match(/company_id=([A-Za-z0-9]+)/);
      if (m) c.companyId = m[1];
    }
    c.currency = c.currency || 'USD';
    c.wishlistUrl = c.wishlistUrl || '/pages/wishlist';
    c.trackAddedToWishlist = c.trackAddedToWishlist !== false;
    c.priceDropViaViewedProduct = c.priceDropViaViewedProduct !== false;
    return c;
  }
  function load() {
    var s = null;
    try { s = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!s || s.v !== 1 || !Array.isArray(s.items)) s = { v: 1, email: '', items: [] };
    if (!s.email && cfg.customerEmail) s.email = cfg.customerEmail;
    return s;
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
    render();
    try { document.dispatchEvent(new CustomEvent('aq:wishlist:change', { detail: { items: state.items.slice() } })); } catch (e) {}
  }
  function find(h) { for (var i = 0; i < state.items.length; i++) if (state.items[i].h === h) return i; return -1; }
  function has(h) { return find(h) > -1; }
  function add(item) {
    if (!item || !item.h) return false;
    var i = find(item.h);
    if (i > -1) { state.items[i] = merge(state.items[i], item); save(); return false; }
    item.ts = Date.now(); item.kl = false;
    state.items.unshift(item);
    save();
    klaviyoTrackItem(item);
    return true;
  }
  function remove(h) { var i = find(h); if (i < 0) return false; state.items.splice(i, 1); save(); return true; }
  function toggle(item) { return has(item.h) ? (remove(item.h), false) : (add(item), true); }
  function merge(a, b) { for (var k in b) if (b[k] !== undefined && b[k] !== '' && k !== 'ts' && k !== 'kl') a[k] = b[k]; return a; }
  function count() { return state.items.length; }

  /* ---------------------------------------------------------------- Klaviyo */
  function kl(method, args) {
    /* klaviyo.js exposes window.klaviyo (a proxy) once loaded; before that, the legacy _learnq queue is
       drained on load. Either way nothing here blocks or throws. */
    try {
      if (window.klaviyo && typeof window.klaviyo[method] === 'function') { window.klaviyo[method].apply(window.klaviyo, args); return; }
      (window._learnq = window._learnq || []).push([method].concat(args));
    } catch (e) {}
  }
  function identify(email) {
    email = String(email || '').trim().toLowerCase();
    if (!validEmail(email)) return false;
    state.email = email;
    kl('identify', [{ email: email }]);
    save();
    return true;
  }
  function eventProps(item) {
    return {
      ProductID: item.id, VariantID: item.vid, ProductName: item.t, Handle: item.h,
      ImageURL: abs(item.img), URL: abs(item.url), Price: num(item.price), CompareAtPrice: num(item.cmp),
      Currency: item.cur || cfg.currency, Available: item.avail !== false, Source: 'wishlist', $value: num(item.price)
    };
  }
  function klaviyoTrackItem(item) {
    if (item.kl) return;
    var p = eventProps(item);
    if (cfg.trackAddedToWishlist) kl('track', ['Added to Wishlist', p]);
    /* Klaviyo's Price Drop trigger audiences are "Viewed the product" / "Started checkout" only, so a save
       is also recorded as a product view (Source: "wishlist" lets flows filter it out if they want to). */
    if (cfg.priceDropViaViewedProduct) {
      kl('track', ['Viewed Product', {
        ProductName: item.t, ProductID: item.id, ImageURL: abs(item.img), URL: abs(item.url), Brand: 'Aquamarise',
        Price: num(item.price), CompareAtPrice: num(item.cmp), Source: 'wishlist'
      }]);
    }
    item.kl = true;
  }
  function subscribeBackInStock(opts) {
    /* Browser-side subscription with the public key only. Klaviyo answers 202 and later fires its
       "Subscribed to Back in Stock" metric -> the Back in Stock flow sends when inventory returns. */
    var email = String(opts.email || state.email || '').trim().toLowerCase();
    if (!cfg.companyId || !validEmail(email) || !opts.variantId) return Promise.reject(new Error('missing email, variant or Klaviyo key'));
    var body = { data: { type: 'back-in-stock-subscription',
      attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
      relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + String(opts.variantId) } } } } };
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': KL_REVISION }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); return true; });
  }
  function syncToKlaviyo() {
    /* Called after the shopper gives an email on the wishlist page: identify, replay unsent saves, and
       register back-in-stock alerts for every saved variant that is currently sold out. */
    if (!state.email) return Promise.resolve(0);
    var n = 0;
    state.items.forEach(function (it) { if (!it.kl) { klaviyoTrackItem(it); n++; } });
    var subs = state.items.filter(function (it) { return it.avail === false && it.vid; })
      .map(function (it) { return subscribeBackInStock({ email: state.email, variantId: it.vid }).catch(function () {}); });
    save();
    return Promise.all(subs).then(function () { return n; });
  }

  /* ---------------------------------------------------------------- helpers */
  function validEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e || ''); }
  function num(v) { v = parseFloat(v); return isNaN(v) ? undefined : v; }
  function abs(u) { if (!u) return u; if (/^https?:/.test(u)) return u; if (u.indexOf('//') === 0) return location.protocol + u; return location.origin + u; }
  function itemFromEl(el) {
    var d = el.dataset;
    return { h: d.handle, id: d.id, vid: d.vid || '', t: d.title || '', img: d.img || '', price: d.price || '',
      cmp: d.cmp || '', url: d.url || ('/products/' + d.handle), avail: d.avail !== '0', cur: d.cur || cfg.currency };
  }
  function money(v, cur) {
    v = num(v); if (v === undefined) return '';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur || cfg.currency }).format(v); }
    catch (e) { return '$' + v.toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function shareUrl() {
    var handles = state.items.map(function (i) { return i.h; }).join(',');
    return location.origin + cfg.wishlistUrl + (handles ? '?items=' + encodeURIComponent(handles) : '');
  }

  /* ---------------------------------------------------------------- UI: hearts + header count */
  function render() {
    var n = count();
    var counters = document.querySelectorAll('[data-aq-wish-count]');
    for (var i = 0; i < counters.length; i++) if (counters[i].textContent !== String(n)) counters[i].textContent = String(n);
    var btns = document.querySelectorAll('[data-aq-wish]');
    for (var j = 0; j < btns.length; j++) {
      var on = has(btns[j].dataset.handle);
      btns[j].setAttribute('aria-pressed', on ? 'true' : 'false');
      btns[j].setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-aq-wish]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var item = itemFromEl(btn);
    /* On a product page the heart follows the selected variant. */
    var form = btn.closest('.product__meta, [data-product-form], form') || document;
    var sel = (btn.dataset.pdp && document.querySelector('[data-product-form] [name="id"]')) || null;
    if (sel && sel.value) item.vid = sel.value;
    var added = toggle(item);
    btn.classList.remove('aq-wish--pop'); void btn.offsetWidth; btn.classList.add('aq-wish--pop');
    if (added && btn.dataset.pdp) showToast(btn);
  }, true);
  function showToast(btn) {
    var t = document.querySelector('[data-aq-wish-toast]');
    if (!t) return;
    t.hidden = false; t.classList.add('is-visible');
    clearTimeout(t.__aq); t.__aq = setTimeout(function () { t.classList.remove('is-visible'); t.hidden = true; }, 3200);
  }
  /* Cards rendered later (infinite scroll, quick view, recommendations) pick up their state here. */
  var mo = new MutationObserver(function () { if (mo.__t) return; mo.__t = setTimeout(function () { mo.__t = 0; render(); }, 60); });
  mo.observe(document.body, { childList: true, subtree: true });

  /* ---------------------------------------------------------------- PDP: back in stock "Get Notified" */
  function initBackInStock() {
    var box = document.querySelector('[data-aq-bis]');
    if (!box) return;
    var form = document.querySelector('[data-product-form]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var oos = {}; (box.dataset.oos || '').split(',').forEach(function (v) { if (v) oos[v] = true; });
    if (!Object.keys(oos).length) return;
    var sel = form.querySelector('[name="id"]');
    function currentVariant() { return (sel && sel.value) || form.dataset.currentProductId || ''; }
    function check() {
      var vid = currentVariant(); var show = !!oos[vid];
      box.hidden = !show; box.dataset.vid = vid;
      form.classList.toggle('aq-bis-active', show);
      if (!show) resetForm();
    }
    var openBtn = box.querySelector('[data-aq-bis-open]');
    var f = box.querySelector('[data-aq-bis-form]');
    var done = box.querySelector('[data-aq-bis-done]');
    var err = box.querySelector('[data-aq-bis-err]');
    function resetForm() { if (f) f.hidden = true; if (openBtn) openBtn.hidden = false; if (done) done.hidden = true; if (err) err.hidden = true; }
    if (openBtn) openBtn.addEventListener('click', function () {
      openBtn.hidden = true; f.hidden = false;
      var inp = f.querySelector('input[type="email"]'); if (inp) { if (!inp.value && state.email) inp.value = state.email; inp.focus(); }
    });
    if (f) f.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = f.querySelector('input[type="email"]'); var email = inp ? inp.value : '';
      if (!validEmail(email)) { if (err) { err.hidden = false; err.textContent = 'Please enter a valid email address.'; } return; }
      if (err) err.hidden = true;
      var submit = f.querySelector('[type="submit"]'); if (submit) submit.disabled = true;
      identify(email);
      subscribeBackInStock({ email: email, variantId: box.dataset.vid }).then(function () {
        f.hidden = true; if (done) done.hidden = false;
        kl('track', ['Requested Back in Stock Alert', { ProductID: box.dataset.productId, VariantID: box.dataset.vid, ProductName: box.dataset.productTitle, URL: location.href.split('?')[0] }]);
      }).catch(function () {
        if (err) { err.hidden = false; err.textContent = 'Something went wrong. Please try again in a moment.'; }
      }).then(function () { if (submit) submit.disabled = false; });
    });
    /* The theme swaps the variant id and disables Add to Cart when a sold-out variant is picked; both are
       attribute changes, so one observer covers every way a shopper can change the selection. */
    new MutationObserver(function () { clearTimeout(check.__t); check.__t = setTimeout(check, 30); })
      .observe(form, { attributes: true, subtree: true, attributeFilter: ['disabled', 'value', 'data-current-product-id', 'selected'] });
    form.addEventListener('change', function () { setTimeout(check, 30); });
    check();
  }

  /* ---------------------------------------------------------------- wishlist page */
  function initPage() {
    var page = document.querySelector('[data-aq-wishlist-page]');
    if (!page) return;
    var grid = page.querySelector('[data-aq-wl-grid]');
    var empty = page.querySelector('[data-aq-wl-empty]');
    var countEl = page.querySelector('[data-aq-wl-count]');
    var alerts = page.querySelector('[data-aq-wl-alerts]');
    var shareBtn = page.querySelector('[data-aq-wl-share]');
    var shareMsg = page.querySelector('[data-aq-wl-share-msg]');

    /* A shared link carries the handles; merge them in, then drop the parameter from the address bar. */
    var params = new URLSearchParams(location.search);
    var shared = (params.get('items') || '').split(',').filter(Boolean);
    if (shared.length) {
      shared.forEach(function (h) { if (!has(h)) { state.items.push({ h: h, ts: Date.now(), kl: true, shared: true }); } });
      save();
      params.delete('items');
      try { history.replaceState(null, '', location.pathname + (params.toString() ? '?' + params : '')); } catch (e) {}
    }

    function productJson(h) {
      var k = 'aq_p_' + h, cached = null;
      try { cached = JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) {}
      if (cached && cached.t > Date.now() - 30 * 60 * 1000) return Promise.resolve(cached.p);
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status); return r.json();
      }).then(function (p) { try { sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), p: p })); } catch (e) {} return p; });
    }
    function refresh(item, p) {
      /* Refresh what we know from the live product: price, stock, image. Keeps price-drop and
         sold-out states accurate without any server of our own. */
      var v = null;
      if (item.vid) for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(item.vid)) v = p.variants[i];
      if (!v) v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      var prev = num(item.price);
      item.id = p.id; item.t = p.title; item.url = '/products/' + p.handle + (v && p.variants.length > 1 ? '?variant=' + v.id : '');
      item.vid = v ? v.id : item.vid; item.avail = v ? !!v.available : !!p.available;
      var img = (v && v.featured_image && v.featured_image.src) || (p.featured_image) || (p.images && p.images[0]) || '';
      item.img = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
      item.price = ((v ? v.price : p.price) / 100).toFixed(2);
      item.cmp = (v && v.compare_at_price) ? (v.compare_at_price / 100).toFixed(2) : '';
      item.dropped = prev !== undefined && num(item.price) < prev;
      /* "Size 7 · Silver" rather than the bare "7 / Silver" variant title. */
      item.vtitle = '';
      if (v && p.variants.length > 1) {
        var parts = [];
        (p.options || []).forEach(function (opt, i) {
          var name = (opt && typeof opt === 'object') ? opt.name : opt; /* /products/x.js gives {name, position, values} */
          var val = v['option' + (i + 1)];
          if (!val || /^default title$/i.test(val)) return;
          parts.push((!name || /^title$/i.test(String(name)) ? '' : String(name) + ' ') + val);
        });
        item.vtitle = parts.join(' \u00b7 ');
      }
      delete item.shared;
      return item;
    }
    function card(item) {
      var sale = item.cmp && num(item.cmp) > num(item.price);
      return '<article class="aq-wl-card" data-handle="' + esc(item.h) + '">' +
        '<a class="aq-wl-card__image" href="' + esc(item.url) + '">' +
          (item.img ? '<img src="' + esc(item.img) + '" alt="' + esc(item.t) + '" loading="lazy" width="600" height="600">' : '') +
          (sale ? '<span class="aq-wl-pill">On sale</span>' : (item.dropped ? '<span class="aq-wl-pill">Price drop</span>' : '')) +
          (item.avail === false ? '<span class="aq-wl-pill aq-wl-pill--muted">Sold out</span>' : '') +
        '</a>' +
        '<button type="button" class="aq-wl-remove" data-aq-wl-remove aria-label="Remove ' + esc(item.t) + ' from wishlist"><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>' +
        '<div class="aq-wl-card__meta">' +
          '<a class="aq-wl-card__title" href="' + esc(item.url) + '">' + esc(item.t || item.h) + '</a>' +
          (item.vtitle ? '<span class="aq-wl-card__variant">' + esc(item.vtitle) + '</span>' : '') +
          '<span class="aq-wl-card__price">' + (sale ? '<s>' + esc(money(item.cmp, item.cur)) + '</s> ' : '') + '<span' + (sale ? ' class="is-sale"' : '') + '>' + esc(money(item.price, item.cur)) + '</span></span>' +
        '</div>' +
        (item.avail === false
          ? '<button type="button" class="aq-wl-cta aq-wl-cta--notify" data-aq-wl-notify data-vid="' + esc(item.vid) + '">Notify me when back</button>'
          : '<a class="aq-wl-cta" href="' + esc(item.url) + '">View piece</a>') +
      '</article>';
    }
    function paint() {
      var items = state.items;
      if (countEl) countEl.textContent = items.length ? (items.length + (items.length === 1 ? ' piece saved' : ' pieces saved')) : '';
      if (!items.length) { grid.innerHTML = ''; grid.hidden = true; empty.hidden = false; if (alerts) alerts.hidden = true; if (shareBtn) shareBtn.hidden = true; return; }
      empty.hidden = true; grid.hidden = false; if (alerts) alerts.hidden = false; if (shareBtn) shareBtn.hidden = false;
      grid.innerHTML = items.map(card).join('');
    }
    paint();
    /* Refresh every saved item from the live catalogue, then repaint once. Products that no longer exist are dropped. */
    Promise.all(state.items.map(function (it) {
      return productJson(it.h).then(function (p) { refresh(it, p); }, function (e) { if (String(e.message) === '404') it.gone = true; });
    })).then(function () {
      state.items = state.items.filter(function (it) { return !it.gone; });
      save(); paint();
    });

    grid.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-aq-wl-remove]');
      if (rm) { remove(rm.closest('.aq-wl-card').dataset.handle); paint(); return; }
      var nt = e.target.closest('[data-aq-wl-notify]');
      if (nt) {
        if (!state.email) { if (alerts) { alerts.scrollIntoView({ behavior: 'smooth', block: 'center' }); var inp = alerts.querySelector('input'); if (inp) inp.focus(); } return; }
        nt.disabled = true; nt.textContent = 'Saving…';
        subscribeBackInStock({ email: state.email, variantId: nt.dataset.vid }).then(function () { nt.textContent = 'We will email you'; })
          .catch(function () { nt.disabled = false; nt.textContent = 'Try again'; });
      }
    });

    if (alerts) {
      var aForm = alerts.querySelector('form'), aDone = alerts.querySelector('[data-aq-wl-alerts-done]'), aErr = alerts.querySelector('[data-aq-wl-alerts-err]');
      var aInp = aForm && aForm.querySelector('input[type="email"]');
      if (aInp && state.email) aInp.value = state.email;
      if (aForm) aForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!identify(aInp.value)) { aErr.hidden = false; return; }
        aErr.hidden = true;
        var b = aForm.querySelector('[type="submit"]'); if (b) b.disabled = true;
        syncToKlaviyo().then(function () {
          aForm.hidden = true; aDone.hidden = false;
          var note = document.querySelectorAll('[data-aq-wl-notify]');
          for (var i = 0; i < note.length; i++) { note[i].disabled = true; note[i].textContent = 'We will email you'; }
        }).catch(function () { if (b) b.disabled = false; });
      });
    }
    if (shareBtn) shareBtn.addEventListener('click', function () {
      var url = shareUrl();
      var say = function (m) { if (shareMsg) { shareMsg.textContent = m; shareMsg.hidden = false; clearTimeout(shareMsg.__t); shareMsg.__t = setTimeout(function () { shareMsg.hidden = true; }, 3500); } };
      if (navigator.share) { navigator.share({ title: 'My Aquamarise wishlist', url: url }).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { say('Link copied'); }, function () { say(url); });
      else say(url);
    });
    document.addEventListener('aq:wishlist:change', function () { if (!grid.children.length !== !state.items.length) paint(); });
  }

  /* ---------------------------------------------------------------- boot */
  window.AQWishlist = { items: function () { return state.items.slice(); }, has: has, add: add, remove: remove, toggle: toggle, count: count,
    email: function () { return state.email; }, setEmail: identify, identify: identify, subscribeBackInStock: subscribeBackInStock,
    syncToKlaviyo: syncToKlaviyo, shareUrl: shareUrl };
  render();
  initBackInStock();
  initPage();
  if (state.email) kl('identify', [{ email: state.email }]);
})();
